import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getHomeViewType } from "../../utils/homeViewType";
import "../HomeBody/HomeBody.css";

export default function SwitchBtn() {
  const { t } = useTranslation();
  const location = useLocation();
  const activeBtn = getHomeViewType(location.pathname);

  const tabClass = (isActive) =>
    `tw-px-4 sm:tw-px-8 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-transition-colors tw-border-0 tw-cursor-pointer tw-whitespace-nowrap ${
      isActive ? "tw-bg-[#712CB0] tw-text-white" : "tw-bg-transparent tw-text-white/60 hover:tw-text-white"
    }`;

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-bg-[#1e0039] tw-py-3 tw-overflow-x-auto no-scrollbar">
      <div className="tw-flex tw-rounded-xl tw-bg-white/10 tw-p-1 tw-gap-1">
        <Link to="/" className="tw-no-underline">
          <button className={tabClass(activeBtn === "epk")}>{t("EPKs")}</button>
        </Link>
        <Link to="/actors" className="tw-no-underline">
          <button className={tabClass(activeBtn === "actor")}>{t("Actors")}</button>
        </Link>
        <Link to="/filmmakers" className="tw-no-underline">
          <button className={tabClass(activeBtn === "filmmaker")}>{t("Filmmakers")}</button>
        </Link>
      </div>
    </div>
  );
}
